import { render, staticRenderFns } from "./Base-layout.vue?vue&type=template&id=3e2baf5e&"
import script from "./Base-layout.vue?vue&type=script&lang=js&"
export * from "./Base-layout.vue?vue&type=script&lang=js&"
import style0 from "./Base-layout.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports